module.exports = __webpack_public_path__ + "static/img/day5.adfc77a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/day5.jpg
// module id = Gpa0
// module chunks = 0